import type { Channel } from './types'

const DEFAULT_DELAYS = [0, 300, 700, 1400, 2600]

const wait = (delay: number) => new Promise<void>((resolve) => window.setTimeout(resolve, delay))

/**
 * Reloads until the connected account shows up. With `accountId` it waits for
 * that exact account; otherwise it waits for an account on `platform` that was
 * not in `knownIds`, so a network that already has one account still has to
 * gain a new one.
 */
export async function reconcileConnectedChannel({
  platform,
  accountId,
  knownIds,
  reload,
  readChannels,
  delays = DEFAULT_DELAYS,
  sleep = wait,
}: {
  platform: string
  accountId?: string
  knownIds?: ReadonlySet<string>
  reload: () => Promise<void>
  readChannels: () => Channel[]
  delays?: number[]
  sleep?: (delay: number) => Promise<void>
}) {
  const matches = (channel: Channel) =>
    accountId
      ? channel.id === accountId
      : channel.platform === platform && !knownIds?.has(channel.id)
  for (const delay of delays) {
    if (delay > 0) await sleep(delay)
    await reload()
    if (readChannels().some(matches)) {
      return true
    }
  }
  return false
}
